import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-a3d797ae"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "order-detail-page"
};
const _hoisted_2 = {
  class: "order-detail-inner"
};
const _hoisted_3 = {
  class: "page-header"
};
const _hoisted_4 = {
  class: "page-header__main"
};
const _hoisted_5 = {
  class: "page-header__title-wrap"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h1", {
  class: "page-title"
}, "订单详情", -1));
const _hoisted_7 = {
  class: "panel panel--hero"
};
const _hoisted_8 = {
  class: "hero-top"
};
const _hoisted_9 = {
  class: "hero-ids"
};
const _hoisted_10 = {
  class: "id-label"
};
const _hoisted_11 = {
  class: "id-value"
};
const _hoisted_12 = {
  class: "id-value__text"
};
const _hoisted_13 = {
  key: 0,
  class: "hero-steps"
};
const _hoisted_14 = {
  class: "step-flow"
};
const _hoisted_15 = {
  class: "step-icon"
};
const _hoisted_16 = {
  key: 1,
  class: "step-icon__dot"
};
const _hoisted_17 = {
  class: "step-name"
};
const _hoisted_18 = {
  class: "step-time"
};
const _hoisted_19 = {
  class: "summary-bar"
};
const _hoisted_20 = {
  class: "s-label"
};
const _hoisted_21 = {
  key: 0,
  class: "s-value"
};
const _hoisted_22 = {
  key: 1,
  class: "s-value-row"
};
const _hoisted_23 = {
  class: "s-value-ellipsis-wrap"
};
const _hoisted_24 = {
  class: "s-value s-value--compact s-value--ellipsis"
};
const _hoisted_25 = {
  key: 2,
  class: "s-value"
};
const _hoisted_26 = {
  class: "body-grid"
};
const _hoisted_27 = {
  class: "body-main"
};
const _hoisted_28 = {
  class: "panel detail-panel"
};
const _hoisted_29 = {
  key: 0,
  class: "section-links"
};
const _hoisted_30 = {
  class: "section-title"
};
const _hoisted_31 = {
  key: 1,
  class: "field-grid"
};
const _hoisted_32 = {
  class: "field-label"
};
const _hoisted_33 = {
  class: "field-value-row"
};
const _hoisted_34 = {
  class: "field-value"
};
const _hoisted_35 = {
  class: "section-title"
};
const _hoisted_36 = {
  key: 0,
  class: "table-cell-copy"
};
const _hoisted_37 = {
  class: "table-cell-copy__text table-cell-copy__text--ellipsis"
};
const _hoisted_38 = {
  class: "body-aside"
};
const _hoisted_39 = {
  class: "panel timeline-panel"
};
const _hoisted_40 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "timeline-head"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "section-title section-title--inline"
}, "订单时间轴")], -1));
const _hoisted_41 = {
  class: "timeline-scroll"
};
const _hoisted_42 = {
  class: "timeline-list"
};
const _hoisted_43 = {
  class: "tl-time"
};
const _hoisted_44 = {
  class: "timeline-item__content"
};
const _hoisted_45 = {
  class: "tl-main-row"
};
const _hoisted_46 = {
  class: "tl-main-info"
};
const _hoisted_47 = {
  class: "tl-title"
};
const _hoisted_48 = {
  class: "tl-desc"
};
const _hoisted_49 = {
  class: "tl-detail-pre"
};
const _hoisted_50 = {
  class: "json-preview"
};
import { computed, ref } from 'vue';
import { message } from 'ant-design-vue';
import { CheckOutlined, CloseOutlined, CopyOutlined, InfoCircleOutlined } from '@ant-design/icons-vue';
import { queryOrderDetail, queryOrderEventDetail } from '@/api/orderApi';
import { copy, OK } from '@/common';
import { getProdTypeLabel } from '@/constants/prodTypeOptions';
import { formatEventTimeMs, formatFieldValue, getByPath, getTimelineErrorDetailText, orderDetailEventListConfig, orderDetailOrderIdsConfig, orderDetailSectionCards, orderDetailStatusConfig, orderDetailSummaryMetricsConfig, orderDetailTables } from './orderDetailConfig';
import { formatOrderOs } from './orderOs';
import { formatRefundStatus } from './refundStatus';
import { formatShipStatus } from './shipStatus';
import { defineComponent } from 'vue';
const __default__ = defineComponent({
  name: 'orderDetail'
});
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props, {
    expose
  }) {
    const orderNo = ref('');
    const dbtId = ref('');
    const visible = ref(false);
    const drawerWidth = '86vw';
    const drawerBodyStyle = {
      padding: '0'
    };
    const loading = ref(false);
    const detail = ref({});
    const eventList = ref([]);
    const previewOpen = ref(false);
    const previewTitle = ref('');
    const previewJson = ref('');
    function display(prop) {
      return formatFieldValue(getByPath(detail.value, prop));
    }
    function displayField(field) {
      const raw = getByPath(detail.value, field.prop);
      if (field.displayFormat === 'os') return formatOrderOs(raw);
      return formatFieldValue(raw);
    }
    function displaySummaryMetric(m) {
      if (m.displayFormat === 'prodType') {
        return getProdTypeLabel(getByPath(detail.value, m.prop));
      }
      if (!m.currencyProp) return display(m.prop);
      const currency = formatFieldValue(getByPath(detail.value, m.currencyProp));
      const amount = formatFieldValue(getByPath(detail.value, m.prop));
      if (currency === '--' && amount === '--') return '--';
      if (currency === '--') return amount;
      if (amount === '--') return currency;
      return `${currency} ${amount}`;
    }
    const sortedEventRecords = computed(() => {
      const list = [...eventList.value];
      const {
        timeKey
      } = orderDetailEventListConfig;
      return list.sort((a, b) => {
        const ta = Number(a[timeKey]);
        const tb = Number(b[timeKey]);
        const na = Number.isFinite(ta) ? ta : 0;
        const nb = Number.isFinite(tb) ? tb : 0;
        return na - nb;
      });
    });
    const statusText = computed(() => {
      const list = sortedEventRecords.value;
      if (!list.length) return '--';
      const latest = list[list.length - 1];
      const {
        titleKey
      } = orderDetailEventListConfig;
      return formatFieldValue(latest[titleKey]);
    });
    const tagColor = computed(() => {
      const c = getByPath(detail.value, orderDetailStatusConfig.tagColorProp);
      const s = c != null && c !== '' ? String(c) : 'default';
      return s === 'default' ? undefined : s;
    });
    /** 详情步骤条时间：支持毫秒时间戳或可被 Date 解析的字符串 */
    function formatDetailStepTime(val) {
      const ms = formatEventTimeMs(val);
      if (ms !== '--') return ms;
      if (val === null || val === undefined || val === '') return '--';
      const parsed = new Date(String(val));
      if (Number.isNaN(parsed.getTime())) return '--';
      return parsed.toLocaleString('zh-CN', {
        hour12: false
      });
    }
    function hasValidDetailStepTime(val) {
      return formatDetailStepTime(val) !== '--';
    }
    const progressCurrent = computed(() => {
      const d = detail.value;
      const hasPay = hasValidDetailStepTime(getByPath(d, 'orderInfo.createDate'));
      const hasShip = hasValidDetailStepTime(getByPath(d, 'orderInfo.lastShipTime'));
      if (hasPay && hasShip) return 2;
      if (hasPay) return 1;
      return 0;
    });
    const stepItems = computed(() => {
      const d = detail.value;
      const pay = formatDetailStepTime(getByPath(d, 'orderInfo.createDate'));
      const ship = formatDetailStepTime(getByPath(d, 'orderInfo.lastShipTime'));
      return [{
        title: '支付成功',
        description: pay !== '--' ? pay : undefined
      }, {
        title: '道具下发',
        description: ship !== '--' ? ship : undefined
      }];
    });
    function tableData(dataProp) {
      const raw = getByPath(detail.value, dataProp);
      if (raw == null) return [];
      if (Array.isArray(raw)) return raw;
      if (typeof raw === 'object') return [raw];
      return [];
    }
    const timelineList = computed(() => {
      const {
        timeKey,
        titleKey,
        descKey
      } = orderDetailEventListConfig;
      return sortedEventRecords.value.map(raw => {
        var _ev$titleKey, _ev$descKey;
        const ev = raw;
        return {
          time: formatEventTimeMs(ev[timeKey]),
          title: String((_ev$titleKey = ev[titleKey]) !== null && _ev$titleKey !== void 0 ? _ev$titleKey : '--'),
          desc: descKey ? String((_ev$descKey = ev[descKey]) !== null && _ev$descKey !== void 0 ? _ev$descKey : '') : '',
          timelineErrorDetailText: getTimelineErrorDetailText(ev)
        };
      });
    });
    function copyField(prop) {
      const text = formatFieldValue(getByPath(detail.value, prop));
      if (text === '--') {
        message.warning('暂无可复制内容');
        return;
      }
      copy(text);
    }
    function formatTableCellText(val, col) {
      if ((col === null || col === void 0 ? void 0 : col.displayFormat) === 'shipStatus') return formatShipStatus(val);
      if ((col === null || col === void 0 ? void 0 : col.displayFormat) === 'refundStatus') return formatRefundStatus(val);
      return formatFieldValue(val);
    }
    function copyTableCell(val, col) {
      const text = formatTableCellText(val, col);
      if (text === '--') {
        message.warning('暂无可复制内容');
        return;
      }
      copy(text);
    }
    function openPreview(act) {
      if (!act.previewPath) {
        message.info('暂无预览数据');
        return;
      }
      const raw = getByPath(detail.value, act.previewPath);
      previewTitle.value = act.modalTitle || '详情';
      previewJson.value = raw !== undefined ? JSON.stringify(raw, null, 2) : '--';
      previewOpen.value = true;
    }
    async function loadPageData() {
      if (!orderNo.value) return;
      loading.value = true;
      try {
        const [detailRes, eventRes] = await Promise.all([queryOrderDetail({
          orderNo: orderNo.value
        }), queryOrderEventDetail({
          orderNo: orderNo.value,
          dbtId: dbtId.value,
          pageArrow: 1,
          pageSize: 9999
        })]);
        if (detailRes.code === OK) {
          var _detailRes$data;
          detail.value = (_detailRes$data = detailRes.data) !== null && _detailRes$data !== void 0 ? _detailRes$data : {};
        }
        if (eventRes.code === OK) {
          var _eventRes$data;
          const list = (_eventRes$data = eventRes.data) === null || _eventRes$data === void 0 ? void 0 : _eventRes$data.eventList;
          eventList.value = Array.isArray(list) ? list : [];
        }
      } catch (error) {
        console.error(error);
      } finally {
        loading.value = false;
      }
    }
    function handleClose() {
      visible.value = false;
    }
    function open(params = {}) {
      orderNo.value = params.orderNo || '';
      dbtId.value = params.dbtId || '';
      detail.value = {};
      eventList.value = [];
      previewOpen.value = false;
      previewTitle.value = '';
      previewJson.value = '';
      visible.value = true;
      loadPageData();
    }
    expose({
      open
    });
    return (_ctx, _cache) => {
      const _component_a_tag = _resolveComponent("a-tag");
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_tooltip = _resolveComponent("a-tooltip");
      const _component_a_table = _resolveComponent("a-table");
      const _component_a_popover = _resolveComponent("a-popover");
      const _component_a_spin = _resolveComponent("a-spin");
      const _component_a_modal = _resolveComponent("a-modal");
      const _component_a_drawer = _resolveComponent("a-drawer");
      return _openBlock(), _createBlock(_component_a_drawer, {
        open: visible.value,
        "onUpdate:open": _cache[1] || (_cache[1] = $event => visible.value = $event),
        placement: "right",
        width: drawerWidth,
        closable: false,
        "body-style": drawerBodyStyle,
        "destroy-on-close": ""
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_a_spin, {
          spinning: loading.value,
          class: "order-detail-spin"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("header", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_hoisted_6, _unref(statusText) && _unref(statusText) !== '--' ? (_openBlock(), _createBlock(_component_a_tag, {
            key: 0,
            class: _normalizeClass(["status-tag", {
              'status-tag--brand': !_unref(tagColor)
            }]),
            color: _unref(tagColor)
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(statusText)), 1)]),
            _: 1
          }, 8, ["class", "color"])) : _createCommentVNode("", true)])]), _createVNode(_component_a_button, {
            type: "text",
            class: "drawer-close-btn",
            onClick: handleClose
          }, {
            icon: _withCtx(() => [_createVNode(_unref(CloseOutlined))]),
            _: 1
          })]), _createElementVNode("section", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(orderDetailOrderIdsConfig).primaryRows, row => {
            return _openBlock(), _createElementBlock("div", {
              key: row.prop,
              class: "id-row"
            }, [_createElementVNode("div", _hoisted_10, _toDisplayString(row.label), 1), _createElementVNode("div", _hoisted_11, [_createElementVNode("span", _hoisted_12, _toDisplayString(display(row.prop)), 1), row.copyable ? (_openBlock(), _createBlock(_component_a_tooltip, {
              key: 0,
              title: "复制",
              "overlay-class-name": "order-detail-copy-tip",
              class: "copy-tooltip-trigger"
            }, {
              default: _withCtx(() => [_createVNode(_unref(CopyOutlined), {
                class: "copy-icon",
                role: "button",
                onClick: $event => copyField(row.prop)
              }, null, 8, ["onClick"])]),
              _: 2
            }, 1024)) : _createCommentVNode("", true)])]);
          }), 128))]), _unref(stepItems).length ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(stepItems), (step, index) => {
            return _openBlock(), _createElementBlock(_Fragment, {
              key: `${step.title}-${index}`
            }, [_createElementVNode("div", {
              class: _normalizeClass(["step-item", {
                'step-item--done': index < _unref(progressCurrent),
                'step-item--current': index === _unref(progressCurrent),
                'step-item--wait': index > _unref(progressCurrent)
              }])
            }, [_createElementVNode("div", _hoisted_15, [index < _unref(progressCurrent) ? (_openBlock(), _createBlock(_unref(CheckOutlined), {
              key: 0
            })) : (_openBlock(), _createElementBlock("span", _hoisted_16))]), _createElementVNode("div", _hoisted_17, _toDisplayString(step.title), 1), _createElementVNode("div", _hoisted_18, _toDisplayString(step.description || '--'), 1)], 2), index !== _unref(stepItems).length - 1 ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["step-connector", {
                'step-connector--done': index < _unref(progressCurrent)
              }])
            }, null, 2)) : _createCommentVNode("", true)], 64);
          }), 128))])])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_19, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(orderDetailSummaryMetricsConfig), m => {
            return _openBlock(), _createElementBlock("div", {
              key: m.prop,
              class: "summary-cell"
            }, [_createElementVNode("div", _hoisted_20, _toDisplayString(m.label), 1), m.prop === 'orderInfo.productQtyText' ? (_openBlock(), _createElementBlock("div", _hoisted_21, "1")) : m.copyable ? (_openBlock(), _createElementBlock("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [_createVNode(_component_a_tooltip, {
              title: displaySummaryMetric(m),
              "overlay-class-name": "order-detail-copy-tip"
            }, {
              default: _withCtx(() => [_createElementVNode("span", _hoisted_24, _toDisplayString(displaySummaryMetric(m)), 1)]),
              _: 2
            }, 1032, ["title"])]), _createVNode(_component_a_tooltip, {
              title: "复制",
              "overlay-class-name": "order-detail-copy-tip",
              class: "copy-tooltip-trigger"
            }, {
              default: _withCtx(() => [_createVNode(_unref(CopyOutlined), {
                class: "copy-icon copy-icon--sm",
                role: "button",
                onClick: $event => copyField(m.prop)
              }, null, 8, ["onClick"])]),
              _: 2
            }, 1024)])) : (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(displaySummaryMetric(m)), 1))]);
          }), 128))])]), _createElementVNode("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, [_createElementVNode("section", _hoisted_28, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(orderDetailSectionCards), section => {
            var _section$actions, _section$fields;
            return _openBlock(), _createElementBlock("div", {
              key: section.key,
              class: "detail-section"
            }, [(_section$actions = section.actions) !== null && _section$actions !== void 0 && _section$actions.length ? (_openBlock(), _createElementBlock("div", _hoisted_29, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.actions, (act, idx) => {
              return _openBlock(), _createBlock(_component_a_button, {
                key: idx,
                type: "link",
                size: "small",
                class: "action-link",
                onClick: $event => openPreview(act)
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(act.label), 1)]),
                _: 2
              }, 1032, ["onClick"]);
            }), 128))])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_30, _toDisplayString(section.title), 1), (_section$fields = section.fields) !== null && _section$fields !== void 0 && _section$fields.length ? (_openBlock(), _createElementBlock("div", _hoisted_31, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.fields, field => {
              return _openBlock(), _createElementBlock("div", {
                key: field.prop,
                class: "field-cell"
              }, [_createElementVNode("div", _hoisted_32, _toDisplayString(field.label), 1), _createElementVNode("div", _hoisted_33, [_createElementVNode("span", _hoisted_34, _toDisplayString(displayField(field)), 1), field.copyable ? (_openBlock(), _createBlock(_component_a_tooltip, {
                key: 0,
                title: "复制",
                "overlay-class-name": "order-detail-copy-tip",
                class: "copy-tooltip-trigger"
              }, {
                default: _withCtx(() => [_createVNode(_unref(CopyOutlined), {
                  class: "copy-icon copy-icon--sm",
                  role: "button",
                  onClick: $event => copyField(field.prop)
                }, null, 8, ["onClick"])]),
                _: 2
              }, 1024)) : _createCommentVNode("", true)])]);
            }), 128))])) : _createCommentVNode("", true)]);
          }), 128)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(orderDetailTables), tb => {
            return _openBlock(), _createElementBlock("div", {
              key: tb.key,
              class: "detail-section detail-section--table"
            }, [_createElementVNode("div", _hoisted_35, _toDisplayString(tb.title), 1), _createVNode(_component_a_table, {
              size: "middle",
              columns: tb.columns,
              "data-source": tableData(tb.dataProp),
              pagination: false,
              "row-key": (_record, i) => `${tb.key}-${i}`,
              class: "detail-table",
              locale: {
                emptyText: '暂无数据'
              }
            }, {
              bodyCell: _withCtx(({
                column,
                text
              }) => [column.copyable ? (_openBlock(), _createElementBlock("span", _hoisted_36, [column.ellipsis ? (_openBlock(), _createBlock(_component_a_tooltip, {
                key: 0,
                title: formatTableCellText(text, column)
              }, {
                default: _withCtx(() => [_createElementVNode("span", {
                  class: _normalizeClass(["table-cell-copy__text", {
                    'table-cell-copy__text--ellipsis': column.ellipsis
                  }])
                }, _toDisplayString(formatTableCellText(text, column)), 3)]),
                _: 2
              }, 1032, ["title"])) : (_openBlock(), _createElementBlock("span", {
                key: 1,
                class: _normalizeClass(["table-cell-copy__text", {
                  'table-cell-copy__text--ellipsis': column.ellipsis
                }])
              }, _toDisplayString(formatTableCellText(text, column)), 3)), _createVNode(_component_a_tooltip, {
                title: "复制",
                "overlay-class-name": "order-detail-copy-tip",
                class: "copy-tooltip-trigger"
              }, {
                default: _withCtx(() => [_createVNode(_unref(CopyOutlined), {
                  class: "copy-icon copy-icon--sm",
                  role: "button",
                  onClick: _withModifiers($event => copyTableCell(text, column), ["stop"])
                }, null, 8, ["onClick"])]),
                _: 2
              }, 1024)])) : column.displayFormat ? (_openBlock(), _createElementBlock("span", {
                key: 1,
                class: _normalizeClass(["table-status", {
                  'table-status--success': /成功|完成|已/.test(formatTableCellText(text, column)),
                  'table-status--pending': /处理中|待/.test(formatTableCellText(text, column)),
                  'table-status--danger': /失败|关闭|拒绝/.test(formatTableCellText(text, column))
                }])
              }, _toDisplayString(formatTableCellText(text, column)), 3)) : (_openBlock(), _createElementBlock(_Fragment, {
                key: 2
              }, [column.ellipsis ? (_openBlock(), _createBlock(_component_a_tooltip, {
                key: 0,
                title: formatTableCellText(text, column)
              }, {
                default: _withCtx(() => [_createElementVNode("span", _hoisted_37, _toDisplayString(formatTableCellText(text, column)), 1)]),
                _: 2
              }, 1032, ["title"])) : (_openBlock(), _createElementBlock(_Fragment, {
                key: 1
              }, [_createTextVNode(_toDisplayString(formatTableCellText(text, column)), 1)], 64))], 64))]),
              _: 2
            }, 1032, ["columns", "data-source", "row-key"])]);
          }), 128))])]), _createElementVNode("aside", _hoisted_38, [_createElementVNode("section", _hoisted_39, [_hoisted_40, _createElementVNode("div", _hoisted_41, [_createElementVNode("div", _hoisted_42, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(timelineList), (ev, i) => {
            return _openBlock(), _createElementBlock("div", {
              key: i,
              class: _normalizeClass(["timeline-item", {
                'timeline-item--done': i < _unref(progressCurrent),
                'timeline-item--current': i === _unref(progressCurrent),
                'timeline-item--wait': i > _unref(progressCurrent)
              }])
            }, [_createElementVNode("div", _hoisted_43, _toDisplayString(ev.time), 1), _createElementVNode("div", _hoisted_44, [_createElementVNode("div", _hoisted_45, [_createElementVNode("div", _hoisted_46, [_createElementVNode("span", _hoisted_47, _toDisplayString(ev.title), 1), ev.desc ? (_openBlock(), _createBlock(_component_a_tooltip, {
              key: 0,
              class: "tl-desc-tooltip",
              placement: "topLeft",
              title: ev.desc
            }, {
              default: _withCtx(() => [_createElementVNode("span", _hoisted_48, _toDisplayString(ev.desc), 1)]),
              _: 2
            }, 1032, ["title"])) : _createCommentVNode("", true)]), ev.timelineErrorDetailText ? (_openBlock(), _createBlock(_component_a_popover, {
              key: 0,
              placement: "leftTop",
              trigger: "click",
              "overlay-class-name": "order-detail-tl-popover"
            }, {
              content: _withCtx(() => [_createElementVNode("pre", _hoisted_49, _toDisplayString(ev.timelineErrorDetailText), 1)]),
              default: _withCtx(() => [_createVNode(_component_a_button, {
                type: "link",
                size: "small",
                class: "tl-view-btn"
              }, {
                default: _withCtx(() => [_createVNode(_unref(InfoCircleOutlined)), _createTextVNode(" 查看 ")]),
                _: 1
              })]),
              _: 2
            }, 1024)) : _createCommentVNode("", true)])])], 2);
          }), 128))])])])])])])]),
          _: 1
        }, 8, ["spinning"]), _createVNode(_component_a_modal, {
          open: previewOpen.value,
          "onUpdate:open": _cache[0] || (_cache[0] = $event => previewOpen.value = $event),
          title: previewTitle.value,
          footer: null,
          width: "560px",
          "destroy-on-close": ""
        }, {
          default: _withCtx(() => [_createElementVNode("pre", _hoisted_50, _toDisplayString(previewJson.value), 1)]),
          _: 1
        }, 8, ["open", "title"])])]),
        _: 1
      }, 8, ["open"]);
    };
  }
});